export const MAQUETA_ROUTE = '/'